module.exports = __webpack_public_path__ + "img/flex16.4cc2edd3.gif";